import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { WaitSmsNodeData } from '../../../node-edit.type';

@Component({
  selector: 'edit-wait-sms',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
  ],
  templateUrl: './edit-wait-sms.component.html',
  styleUrl: './edit-wait-sms.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditWaitSmsComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditWaitSmsComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<WaitSmsNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public form!: UntypedFormGroup;

  public ngOnInit(): void {
    const timeoutS = this.selectedNodeForEdit()?.data?.timeoutS ?? null;

    this.form = this.fb.group({
      name: [
        {
          value: this.selectedNodeForEdit()?.data?.name ??
            this.translateService.instant('FLOW_CHART.NODES.WAIT_SMS.NAME'),
          disabled: this.disableForm(),
        },
        [Validators.required],
      ],
      timeoutS: [{
        value: timeoutS,
        disabled: this.disableForm(),
      }, [Validators.required]],
    });
  }
}
